import _v from './vars';
import _u from './util';
import SmoothScroll from 'smooth-scroll';

let menuScrollTimeout;
let menuScroll = new SmoothScroll(null, { speed: 150, easing: 'easeInOutQuad' });
	
let gQlCityVars = {
    "cityZip": ""
};

let gQlCityQuery = {	
  query: `
    query fetchDmaData ($cityZip:String!) {
	  getDmaData(cityorzip: $cityZip) {
		city
		state
		dmac
		region
	  }
	}
  `,	  
  variables: gQlCityVars  
};

function callCityLookup(cityZip) {
	gQlCityVars.cityZip = cityZip;
	return fetch("https://www." + _u.getDomain() + "medscape.com/api/salary/graphql", {
	   method: "POST",
	   headers: {
		"Content-Type": "application/json"
	   },
	   body: JSON.stringify(gQlCityQuery)
	})
	.then(res => {
	  return res.json();
	})
	.then(resData => {
	  return resData;
	})
	.catch(err => {
	  console.log(err);
	});
}

let keyDebounce = null;
let pendingPromise = null;
let currentPromise = null;

function handleTypeAhead(e) {
	
	var self = this;
	
	if (e.which != 13 && e.which != 40 && e.which != 39 && e.which != 38 && e.which != 37) {
				
		if (!_v.blockTyping && self.value.length >= 3 && ((e.which >= 48 && e.which <= 57) || (e.which >= 65 && e.which <= 90))) {
			self.classList.add('loading');
		}
		
		clearTimeout(keyDebounce);
		keyDebounce = setTimeout(function() {
			if (self.value.length >= 3 && self.value.indexOf(',') == -1) {
				
				if (pendingPromise == null) {
					pendingPromise = callCityLookup(self.value.replace( /\b./g, function(a){ return a.toUpperCase(); } ));
					currentPromise = pendingPromise;
				} else {
					currentPromise = pendingPromise.then(function() {
						return pendingPromise = callCityLookup(self.value.replace( /\b./g, function(a){ return a.toUpperCase(); } ));
					});
				}
				
				currentPromise.then(function(locResults) {
					self.parentNode.querySelector('.slry-sel').innerHTML = '';
					if (locResults.data.getDmaData.length > 0) {
						self.parentNode.classList.add('active');
						setTimeout(function() {
							self.parentNode.querySelector('.slry-sel').classList.add('active');							
						}, 350);
						let limit = 5;
						if (locResults.data.getDmaData.length < 5) {
							limit = locResults.data.getDmaData.length;
						}
						let firstCity = locResults.data.getDmaData[0].city;		
						let cityAmt = 0;
						
						locResults.data.getDmaData.forEach(function(loc, idx) {					
							if (idx > limit) {
								if (loc.city == firstCity) {
									cityAmt = idx + 1;
								}
							}
						});
						if (cityAmt > 0) {
							limit = cityAmt;
						}
						
						for (var x = 0; x < limit; x++) {
							let resElem = document.createElement('a');
							resElem.className = 'slry-sel-opt';
							resElem.innerHTML = locResults.data.getDmaData[x].city + ', ' + locResults.data.getDmaData[x].state;
							resElem.setAttribute('data-dma', locResults.data.getDmaData[x].dmac);
							resElem.setAttribute('data-state', locResults.data.getDmaData[x].state);
							resElem.setAttribute('data-region', locResults.data.getDmaData[x].region);
							resElem.setAttribute('tabindex', '0');
							self.parentNode.querySelector('.slry-sel').appendChild(resElem);				
						}
						
						document.dispatchEvent(new CustomEvent('locsReady'));
							
						if (locResults.data.getDmaData.length == 1) {
							let locElems = self.parentNode.querySelectorAll('.slry-sel-opt');
							_v.blockTyping = true;
							locElems[0].click();
							self.focus();
						}
						else {
							clearTimeout(menuScrollTimeout);
							menuScrollTimeout = setTimeout(function(){
								if (self.parentNode.querySelector('.slry-sel').getBoundingClientRect().bottom > window.innerHeight) {
									let menuScrollOffset = Math.ceil(self.parentNode.querySelector('.slry-sel').getBoundingClientRect().bottom - window.innerHeight);
									if (typeof breakpoint != 'undefined' && breakpoint < 3 && document.querySelector('.slry-filt-bar').classList.contains('active')) { // Modal layer visible on lower BP
										document.querySelector('.slry-filt-modal').scrollTop = document.querySelector('.slry-filt-modal').scrollTop + menuScrollOffset;
									} else if (document.querySelector('.slry-welc-abt').classList.contains('active')) {
										menuScroll.cancelScroll();
										menuScroll.animateScroll(window.pageYOffset + menuScrollOffset);
									}
								}
							}, 100);
						}
						
					} else {				
						self.parentNode.classList.add('active');
						let resElem = document.createElement('a');
						resElem.className = 'slry-sel-opt';
						resElem.innerHTML = 'No results found';
						self.parentNode.querySelector('.slry-sel').appendChild(resElem);	
					}
					pendingPromise = null;
					currentPromise = null;
					self.classList.remove('loading');					
				});
				
			} else if (self.value.length >= 3 && self.value.indexOf(',') != -1) {
				let locElems = self.parentNode.querySelectorAll('.slry-sel-opt');				
				for (let x = 0; x < locElems.length; x++) {					
				
					let resRegExNoState = new RegExp(locElems[x].innerText.split(',')[0] + ', ?', "gi");
					let resRegExPartial = new RegExp(locElems[x].innerText.split(',')[0] + ', ?' + locElems[x].getAttribute('data-state').charAt(0), "gi");
					let resRegExFull = new RegExp(locElems[x].innerText.split(',')[0] + ', ?' + locElems[x].getAttribute('data-state'), "gi");				
					let noStateMatch = self.value.match(resRegExNoState);
					let partMatch = self.value.match(resRegExPartial);
					let fullMatch = self.value.match(resRegExFull);	
					
					if (fullMatch != null) {
						_v.blockTyping = true;
						locElems[x].click();
						self.focus();
						break;
					} else if (noStateMatch == null) {
						locElems[x].style.display = 'none';												
					} else if (partMatch == null && self.value.split(',')[1].trim().length > 0) {
						locElems[x].style.display = 'none';
					} else if (partMatch != null) {
						locElems[x].style.display = 'block';
					} else if (noStateMatch != null && self.value.split(',')[1].trim().length == 0) {
						locElems[x].style.display = 'block';
					}
					
				}
				
				self.classList.remove('loading');
				document.dispatchEvent(new CustomEvent('locsReady'));
					
				let visLocs = 0;
				let visElem = null;
				locElems.forEach(function(elem) {
					if (elem.offsetParent != null) {
						visLocs++;
						visElem = elem;
					}
				});
				if (visLocs == 1) {
					_v.blockTyping = true;		
					visElem.click();
					self.focus();
				} else {
					clearTimeout(menuScrollTimeout);
					menuScrollTimeout = setTimeout(function(){
						if (self.parentNode.querySelector('.slry-sel').getBoundingClientRect().bottom > window.innerHeight) {
							let menuScrollOffset = Math.ceil(self.parentNode.querySelector('.slry-sel').getBoundingClientRect().bottom - window.innerHeight);
							if (typeof breakpoint != 'undefined' && breakpoint < 3 && document.querySelector('.slry-filt-bar').classList.contains('active')) { // Modal layer visible on lower BP
								document.querySelector('.slry-filt-modal').scrollTop = document.querySelector('.slry-filt-modal').scrollTop + menuScrollOffset;
							} else if (document.querySelector('.slry-welc-abt').classList.contains('active')) {
								menuScroll.cancelScroll();
								menuScroll.animateScroll(window.pageYOffset + menuScrollOffset);
							}
						}
					}, 100);
				}				
			} else {
				self.parentNode.classList.remove('active');
				self.parentNode.querySelector('.slry-sel').classList.remove('active');
				self.parentNode.querySelector('.slry-sel').innerHTML = '';
				self.classList.remove('loading');
			}

		}, 175);
	
	}
}

export default handleTypeAhead;